import {
  DeleteOutlined,
  DiffOutlined,
  EditOutlined,
  FieldTimeOutlined,
  PlusOutlined
} from '@ant-design/icons'
import { Button, Empty, Form, Pagination, Space, Tooltip } from 'antd'
import dayjs from 'dayjs'
import get from 'lodash.get'
import React, { useEffect, useMemo, useState } from 'react'
import {
  convertPriceToNumber,
  formatCurrency,
  formatCurrencyLabel,
  getLabelByValue,
  hasPermission,
  removeNullUndefined
} from '../../config-func'
import { PAGE_SIZE_OPTIONS } from '../../configData'
import { departmentSearch } from '../../services/cmsservice'
import {
  addressSearch,
  addressSearchAll,
  getListStaff,
  projectSearch
} from '../../services/postservice'
import {
  requestAdd,
  requestDelete,
  requestDetail,
  requestSearch,
  requestUpdate
} from '../../services/requestservice'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import PhoneVisibilityCell from '../common/PhoneVisibilityCell'
import ExportButton from '../common/ExportButton'
import TableField from '../common/Table/TableField'
import CallModal from './CallModal'
import {
  APARTMENT_TYPE,
  BALCONY_DIRECTION,
  NHU_CAU,
  ProductType,
  status
} from './configs'
import FilterForm from './FilterForm'
import FormAddExcel from './FormAddExcel'
import FormPost from './FormPost'
import ManagementRequest from './ManageRequest'
import Note from './Note'
import { getAllSelectionsList } from '../../services/selection-list-service'
import {
  buildSubProductTypeFromCategory,
  getSubProductType,
  mapSelectionByCategory
} from '../../utils/helpers'
import Description from './Description'
import Loading from '../Loading'

export const ACTION_MODE = {
  VIEW: 'VIEW',
  ADD: 'ADD',
  UPDATE: 'UPDATE'
}

const ManagerRequestPostWeb = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [formSearch] = Form.useForm()
  const [listDepartment, setListDepartment] = useState([])
  const [data, setData] = useState([])
  // Form thêm mới
  const [loading, setLoading] = useState(false)
  const [postType, setPostType] = useState('')
  const [typeRealEstate, setTypeRealEstate] = useState([])
  const [pagination, setPagination] = useState({
    current: 1, // Trang hiện tại
    pageSize: 10 // Số bản ghi mỗi trang
  })
  // get arr select
  const [listUser, setListUser] = useState([])
  const [listRequest, setListRequest] = useState([])
  const [cities, setCities] = useState([])
  const [districts, setDistricts] = useState([])
  const [towns, setTowns] = useState([])

  const [isModalImportOpen, setIsModalImportOpen] = useState(false)
  const [isModalManagerRequest, setIsModalManagerRequest] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [listAllSelections, setListAllSelections] = useState([])
  const [demandOps, setDemandOps] = useState([])
  const [typeOfRealEstateOps, setTypeOfRealEstateOps] = useState([])
  const [apartmentLocationOptions, setApartmentLocationOptions] = useState([])
  const [directionOptions, setDirectionOptions] = useState([])
  const [furnitureOptions, setFurnitureOptions] = useState([])
  const [legalOptions, setLegalOptions] = useState([])
  const [procedureOptions, setProcedureOptions] = useState([])
  const [currentStatusOpstions, setCurrentStatusOpstions] = useState([])
  const [postStatusOptions, setPostStatusOptions] = useState([])
  const [postSecurityOptions, setPostSecurityOptions] = useState([])

  // state Modal
  const [recordId, setRecordId] = useState()
  const [isOpenCall, setIsOpenCall] = useState(false)
  const [isOpenCopy, setIsOpenCopy] = useState(false)
  const [isOpenBook, setIsOpenBook] = useState(false)
  const [isModalNote, setIsModalNote] = useState(false)
  const [isModalDescription, setIsModalDescription] = useState(false)

  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60
      // render: (_, __, index) => (page - 1) * pageSize + index + 1
    },
    {
      title: 'Nhu cầu',
      dataIndex: 'request_type',
      key: 'request_type',
      width: 100,
      render: (value) => {
        const nhuCau = NHU_CAU.find((item) => item.value === value)
        return nhuCau ? nhuCau.label : '-' // Nếu không tìm thấy, hiển thị "-"
      }
    },
    {
      title: 'Người yêu cầu',
      dataIndex: 'customer_full_name',
      key: 'customer_full_name',
      width: 150
    },
    {
      title: 'Điện thoại',
      dataIndex: 'customer_phone_number',
      key: 'customer_phone_number',
      width: 170,
      render: (_, record) => (
        <PhoneVisibilityCell
          value={record?.customer_phone_number}
          requestId={record?.id}
          type="request"
        />
      )
    },
    {
      title: 'Xác thực định danh',
      dataIndex: 'identifier_type',
      key: 'identifier_type',
      width: 170,
      render: (_, record) => (
        <span>
          {record.identifier_type == 'CUSTOMER'
            ? 'Khách hàng'
            : 'Môi giới bất động sản'}
        </span>
      )
    },
    // {
    //   title: 'Tên Sàn',
    //   dataIndex: 'department_id',
    //   key: 'department_id',
    //   width: 120,
    //   render: (_, record, index) => {
    //     const name = listDepartment?.find(
    //       (n) => n.id === record.department_id
    //     )?.name
    //     return <span>{name}</span>
    //   }
    // },
    // {
    //   title: 'Quản lý tin',
    //   dataIndex: 'request_history_assigns',
    //   key: 'request_history_assigns',
    //   width: 150,
    //   render: (_, record) => {
    //     const name = record?.request_history_assigns?.map(
    //       (n) => n?.assigner_info?.name
    //     )

    //     return <div>{name?.join(' , ')}</div>
    //     // return <span>{record?.request_history_assigns?.[0]?.assigner_info?.name || ''}</span>
    //   }
    //   // render: (text, record) => {
    //   //   const userIds = record.post_manager_info.map(
    //   //     (post) => post.manager_post_id
    //   //   )

    //   //   const names = listUserDepartment
    //   //     .filter((user) => userIds.includes(user.id))
    //   //     .map((user) => user.name)
    //   //     .join(', ')
    //   //   return <>{names}</>
    //   // }
    // },
    {
      title: 'Loại BĐS',
      dataIndex: 'post_type',
      key: 'post_type',
      width: 120,
      render: (_, record) => (
        <span>
          {typeOfRealEstateOps.find((n) => n.value === String(record.post_type))
            ?.label || ''}
        </span>
      )
    },
    {
      title: 'Loại hình BĐS',
      dataIndex: 'type_real_estate',
      key: 'type_real_estate',
      width: 150,
      render: (_, record) => (
        <span>
          <span>
            {getLabelByValue(record.type_real_estate, listAllSelections)}
          </span>
        </span>
      )
    },
    {
      title: 'Tỉnh/Thành phố',
      dataIndex: 'city_code',
      key: 'city_code',
      width: 150,
      render: (_, record) => <span>{record?.city_info?.name}</span>
      // render: (_, record) => (
      //   <span>
      //     {cities.find((n) => n.code === record.city_code)?.name || ''}
      //   </span>
      // )
    },
    {
      title: 'Quận/Huyện',
      dataIndex: 'district_code',
      key: 'district_code',
      width: 120,
      render: (_, record) => <span>{record?.district_info?.name}</span>
    },
    {
      title: 'Phường/Xã',
      dataIndex: 'town_code',
      key: 'town_code',
      width: 120,
      render: (_, record) => <span>{record?.town_info?.name}</span>
    },
    {
      title: 'Đường phố',
      dataIndex: 'street',
      key: 'street',
      width: 120
    },
    {
      title: 'Gói tin',
      dataIndex: 'priority',
      key: 'priority',
      width: 120,
      render: (_, record) => (
        <span>
          {record.priority == 1
            ? 'Limited'
            : record.priority == 2
            ? 'Luxury'
            : record.priority == 3
            ? 'Premium'
            : record.priority == 4
            ? 'Deluxe'
            : record.priority == 5
            ? 'Basic'
            : ''}
          {/* {status.find((n) => n.value === record.status)?.label || ''} */}
        </span>
      )
    },
    {
      title: 'Hiện trạng',
      dataIndex: 'priority',
      key: 'priority',
      width: 120,
      render: (_, record) => (
        <span>
          {/* {status.find((n) => n.value === record.status)?.label || ''} */}
          {record.priority && record.priority == 999
            ? 'Hết hạn'
            : 'Đang hiển thị'}
        </span>
      )
    },
    {
      title: 'Diện tích (m2)',
      dataIndex: 'acreage',
      key: 'acreage',
      width: 150
    },
    {
      title: 'Mặt tiền (m)',
      dataIndex: 'area_outside',
      key: 'area_outside',
      width: 150
    },
    {
      title: 'Số tầng',
      dataIndex: 'number_of_floor',
      key: 'number_of_floor',
      width: 120
    },
    {
      title: 'Số phòng ngủ',
      dataIndex: 'number_of_bedrooms',
      key: 'number_of_bedrooms',
      width: 150
    },
    // {
    //   title: 'Số WC',
    //   dataIndex: 'number_of_bathrooms',
    //   key: ''
    // },
    {
      title: 'Vị trí',
      dataIndex: 'apartment_location',
      key: 'apartment_location',
      width: 120,
      render: (_, record) => {
        const type = APARTMENT_TYPE.find(
          (item) => item.value === record.apartment_location
        )
        return <span>{type ? type.label : ''}</span>
      }
    },
    {
      title: 'Hướng',
      dataIndex: 'direction',
      key: 'direction',
      width: 120,
      render: (_, record) => {
        const type = BALCONY_DIRECTION.find(
          (item) => item.value === record.direction
        )
        return <span>{type ? type.label : ''}</span>
      }
    },
    // {
    //   title: 'Nội thất',
    //   dataIndex: 'description',
    //   key: 'description'
    // },
    {
      title: 'Tài chính',
      dataIndex: 'price',
      key: 'price',
      width: 120,
      render: (_, record) => <span>{formatCurrencyLabel(record.price)}</span>
    },
    // {
    //   title: 'Mô tả',
    //   dataIndex: 'description',
    //   key: 'description',
    //   width: 120
    // },
    // {
    //   title: 'Note',
    //   dataIndex: 'note',
    //   key: 'note'
    // },
    {
      title: 'Email',
      dataIndex: 'customer_email',
      key: 'customer_email',
      width: 120
      // render: (_, record) => <span>{record.user_info?.email}</span>
    },
    {
      title: 'Thời gian đăng',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 150,
      render: (_, record) => (
        <span>
          {record?.created_at
            ? dayjs.unix(record?.created_at).format('DD/MM/YYYY')
            : ''}
        </span>
      )
    },
    {
      title: 'Thời gian gia hạn',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 170,
      render: (_, record) => (
        <span>
          {record?.updated_at
            ? dayjs.unix(record?.updated_at / 1000).format('DD/MM/YYYY')
            : ''}
        </span>
      )
    },
    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            {hasPermission('P83.1', permissions) && (
              <Tooltip title="Chỉnh sửa">
                <Button
                  style={{ width: 32 }}
                  icon={<EditOutlined />}
                  onClick={() => {
                    setMode(ACTION_MODE.UPDATE)
                    getDetailRequest(record.id)
                  }}
                />
              </Tooltip>
            )}
            {/* {hasPermission('P38.6', permissions) && (
              <Tooltip title="Xem lịch sử">
                <Button
                  onClick={() => {
                    setRecordId(record.id)
                    setIsOpenCall(true)
                  }}
                >
                  <FieldTimeOutlined />
                  Xem lịch sử
                </Button>
              </Tooltip>
            )} */}
            {/* <Tooltip title="Xem lịch sử Copy">
              <Button
                onClick={() => {
                  setRecordId(record.id)
                  setIsOpenCopy(true)
                }}
              >
                <FieldTimeOutlined />
                Share
              </Button>
            </Tooltip>
            <Tooltip title="Xem lịch sử Book">
              <Button
                onClick={() => {
                  setRecordId(record.id)
                  setIsOpenBook(true)
                }}
              >
                <FieldTimeOutlined />
                Book
              </Button>
            </Tooltip> */}
            {/* {hasPermission('P38.7', permissions) && (
              <Tooltip title="Xem lịch sử Note">
                <Button
                  onClick={() => {
                    // setMode(ACTION_MODE.UPDATE)
                    // getDetailRequest(record.id)
                    setRecordId(record.id)
                    setIsModalNote(true)
                  }}
                >
                  <FieldTimeOutlined />
                  Note
                </Button>
              </Tooltip>
            )} */}
            {hasPermission('P83.3', permissions) && (
              <Tooltip title="Xem mô tả">
                <Button
                  onClick={() => {
                    setRecordId(record.id)

                    setIsModalDescription(true)
                  }}
                >
                  <FieldTimeOutlined />
                  Mô tả
                </Button>
              </Tooltip>
            )}
            {/* </Tooltip> */}

            {hasPermission('P83.4', permissions) && (
              <Tooltip title="Xóa">
                <Button
                  style={{ width: 32 }}
                  icon={<DeleteOutlined style={{ color: 'red' }} />}
                  onClick={() =>
                    showConfirm({
                      title: 'Xác nhận xoá',
                      content: (
                        <div>
                          Bạn có chắc chắn muốn xoá yêu cầu
                          <b>
                            {' '}
                            {record.request_type == 'RENTING'
                              ? 'thuê'
                              : 'bán'}{' '}
                          </b>
                          của <b>{record.customer_full_name}</b> không?
                        </div>
                      ),
                      onOk: () => deleteRequest([record.id])
                    })
                  }
                />
              </Tooltip>
            )}
          </Space>
        )
      }
    }
  ]
  const SUB_PRODUCT_TYPE_DYNAMIC = useMemo(
    () =>
      buildSubProductTypeFromCategory(listAllSelections, [
        'APARTMENT_BDS',
        'BUILDING_BDS',
        'GROUND_BDS',
        'REAL_ESTATE_BDS'
      ]),
    [listAllSelections]
  )

  // Render loại hình BĐS theo loại BĐS
  const onChangePostType = (e) => {
    const type = getSubProductType(e, SUB_PRODUCT_TYPE_DYNAMIC)

    // const formattedArray = type?.map((item) => ({ value: item, label: item }))
    form.setFieldsValue({
      type_real_estate: null
    })
    setTypeRealEstate(type)
    setPostType(e)
  }

  // Lấy danh sách
  const getListRequest = async (values = {}) => {
    setLoading(true)

    const value = removeNullUndefined(values)
    try {
      const deId = localStorage.getItem('department_id')
      const user_role = localStorage.getItem('user_role')
      let body = {}
      if (user_role == 'ADMIN') {
        body = {
          ...value,
          from: '1',
          pageSize: pagination.pageSize,
          sortBy: 'id'
        }
      } else {
        body = {
          ...value,
          from: '1',
          department_id: deId,
          pageSize: pagination.pageSize,
          sortBy: 'id'
        }
      }
      const res = await requestSearch(body)

      setData(res.data)
      // setPagination((prev) => ({
      //   ...prev
      // }))
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
    }
  }

  useMemo(() => {
    if (pagination.current && pagination.pageSize) {
      const value = formSearch.getFieldsValue()
      getListRequest({
        ...value,
        page: pagination.current,
        pageSize: pagination.pageSize
      })
    }
  }, [pagination.current, pagination.pageSize])

  // Khi thay đổi trang
  const handlePageChange = (current, pageSize) => {
    setPagination((prev) => ({
      ...prev,
      current: prev.pageSize !== pageSize ? 1 : current, // Nếu đổi pageSize thì reset current
      pageSize
    }))
  }

  // Thêm sửa
  const handleSave = async () => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await form.validateFields()
      const { id, assigner_id, ...data } = values
      let body = {}
      mode == ACTION_MODE.ADD
        ? (body = {
            ...data,
            assigner_id: assigner_id,
            price: values.price
              ? convertPriceToNumber(values.price?.toString())
              : 0
          })
        : (body = {
            ...data,
            id: id,
            price: values.price
              ? convertPriceToNumber(values.price?.toString())
              : 0
          })
      if (!values.price || values.price === 0) {
        delete body.price
      }
      const res =
        mode == ACTION_MODE.ADD
          ? await requestAdd(body)
          : await requestUpdate(body)
      if (res && res.data?.id) {
        openNotification(
          'success',
          mode == ACTION_MODE.ADD
            ? 'Tạo tin thành công'
            : 'Cập nhật tin thành công'
        )
        const value = formSearch.getFieldsValue()
        getListRequest({
          ...value,
          page: pagination.current,
          pageSize: pagination.pageSize
        })
        form.resetFields()
        setIsModalOpen(false)
        setLoading(false)
      } else {
        setLoading(false)

        openNotification('error', 'Đã có lỗi xảy ra')
      }
    } catch (err) {
      setLoading(false)

      // Lấy danh sách lỗi từ API
      const errors = get(err, 'response.data.message', [])

      // Xử lý lỗi nếu là mảng
      const errorMessages = Array.isArray(errors)
        ? errors.map((error) => error.message).join('\n')
        : errors // Nếu không phải mảng, lấy trực tiếp

      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
    }
  }

  // Xóa quyền
  const deleteRequest = async (ids) => {
    setLoading(true)
    try {
      // Validate các trường trong form
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      const deId = localStorage.getItem('department_id')
      // Lọc ra các key có giá trị true và đưa vào mảng
      const body = {
        ids,
        department_id: deId
      }
      const res = await requestDelete(body)
      const value = formSearch.getFieldsValue()
      getListRequest({
        ...value,
        page: pagination.current,
        pageSize: pagination.pageSize
      })
      setSelectedRowKeys([])
      setLoading(false)
      openNotification('success', res.message)
    } catch (err) {
      setLoading(false)

      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  // Chi tiết quyền
  const getDetailRequest = async (id) => {
    setLoading(true)
    try {
      const res = await requestDetail(id) // Assuming roleSearch is an API function

      if (res && res.data) {
        setIsModalOpen(true)
        const values = {
          ...res.data,

          request_type: String(res.data.request_type),
          post_type: String(res.data.post_type),
          type_real_estate: String(res.data.type_real_estate),
          apartment_location: String(res.data.apartment_location),
          direction: String(res.data.direction)
        }
        form.setFieldsValue({
          ...values,
          price: values.price ? formatCurrency(values.price) : ''
        })
        getListDistricts(values.city_code)
        getListTowns(values.district_code)
        const type = getSubProductType(
          values.post_type,
          SUB_PRODUCT_TYPE_DYNAMIC
        )
        setTypeRealEstate(type)
        setPostType(values.post_type)
        getUserAll(values.department_id)
        setLoading(false)
      } else {
      }
    } catch (err) {
      setLoading(false)

      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  // Danh sách sàn
  const getDepartmentAll = async (values) => {
    let { name = '', type = '', page = 1, pageSize = 1000 } = values || {}
    try {
      const body = { name, type, page, pageSize }
      const res = await departmentSearch(body)
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.id,
        label: item.name
      }))
      setListDepartment(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  // Danh sách tài khoản theo SÀN
  const getUserAll = async (id) => {
    let page = 1
    let pageSize = 1000

    try {
      const body = {
        page,
        pageSize,
        department_id: id
      }
      const res = await getListStaff(body) // Assuming roleSearch is an API function
      if (res && res?.data?.list) {
        const result = res?.data?.list.map((item) => ({
          ...item,
          value: item.id,
          label: item.name
        }))
        setListUser(result) // Update the state with the list of roles
      } else {
        // Handle the case where the response is unexpected or empty

        setListUser([]) // Optionally, reset the list to an empty array
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
      setListUser([]) // Optionally, reset the list to an empty array
    }
  }

  const user_role = localStorage.getItem('user_role')
  const deId = localStorage.getItem('department_id')
  useEffect(() => {
    if (user_role == 'ADMIN') {
      getUserAll('')
    } else {
      getUserAll(deId)
    }
  }, [user_role])

  // Danh sách dự án
  const getProjectAll = async (values) => {
    let { page = 1, pageSize = 100 } = values || {}
    try {
      const body = { page, pageSize }
      const res = await projectSearch(body)
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.id,
        label: item.project_name
      }))

      setListRequest(result)
    } catch (err) {}
  }
  // Danh sách thành phố
  const getListCities = async () => {
    try {
      const res = await addressSearch('', 'city')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setCities(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  // Danh sách quận huyện
  const getListDistricts = async (code) => {
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'district')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setDistricts(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  // Danh sách phường xã
  const getListTowns = async (code) => {
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'town')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setTowns(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  useEffect(() => {
    getDepartmentAll()
    // getProjectAll()
    getListCities()
  }, [])

  // func
  const onChangeProject = async (value) => {
    const dataProject = _.find(listRequest, (el) => el.id === value)

    await getListDistricts(dataProject.city_code)
    await getListTowns(dataProject.district_code)

    form.setFieldsValue({
      city_code: dataProject.city_code,
      district_code: dataProject.district_code,
      town_code: dataProject.town_code,
      street: dataProject.address,
      project_name: dataProject.project_name
    })
  }

  // Chọn city hay district thì call api
  const onChangeCity = (e) => {
    getListDistricts(e)
    form.setFieldsValue({
      district_code: null,
      town_code: null
    })
  }
  const onChangeDistrict = (e) => {
    const code = districts.filter((item) => item.code == e)?.[0]?.code

    getListTowns(code)
    form.setFieldsValue({
      town_code: null
    })
  }

  const onChangeDepartment = async (value) => {
    // await getUserAll(value)
    // form.setFieldsValue({
    //   manager_post_id: null
    // })
  }

  const [citiesAll, setCitiesAll] = useState([])
  const [districtsAll, setDistrictsAll] = useState([])
  const [townsAll, setTownsAll] = useState([])

  // Danh sách thành phố
  const getListCitiesAll = async () => {
    try {
      const res = await addressSearch('', 'city')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setCitiesAll(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  // Danh sách quận huyện
  const getListDistrictsAll = async () => {
    try {
      const res = await addressSearchAll('district')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setDistrictsAll(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  // Danh sách phường xã
  const getListTownsAll = async () => {
    try {
      const res = await addressSearchAll('town')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setTownsAll(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  const getSelection = async () => {
    try {
      const res = await getAllSelectionsList()
      setListAllSelections(res || [])
    } catch (err) {}
  }

  useEffect(() => {
    getListCitiesAll()
    getListDistrictsAll()
    getListTownsAll()
    getSelection()
  }, [])
  useEffect(() => {
    setTimeout(() => {
      mapSelectionByCategory(listAllSelections, [
        {
          // nhu cầu
          category: 'DEMAND',
          setState: setDemandOps
        },
        {
          // loại bất động sản
          category: 'TYPE_OF_REAL_STATE',
          setState: setTypeOfRealEstateOps
        },
        {
          // vị trí căn hộ
          category: 'LOCATION',
          setState: setApartmentLocationOptions
        },
        {
          // hướng căn hộ
          category: 'DIRECTION',
          setState: setDirectionOptions
        },
        {
          // phí giao dịch
          category: 'PROCEDURE',
          setState: setProcedureOptions
        },
        {
          // giấy tờ pháp lý
          category: 'LEGAL',
          setState: setLegalOptions
        },
        {
          // nội thất
          category: 'FURNITURE',
          setState: setFurnitureOptions
        },
        {
          // hiện trạng
          category: 'CURRENT_STATUS',
          setState: setCurrentStatusOpstions
        },
        {
          // trạng thái tin
          category: 'POST_STATUS',
          setState: setPostStatusOptions
        },
        {
          // trạng thái tin
          category: 'POST_SECURITY',
          setState: setPostSecurityOptions
        }
      ])
    }, 0)
  }, [listAllSelections])
  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <FilterForm
          form={formSearch}
          getListRequest={getListRequest}
          listDepartment={listDepartment}
          listRequest={listRequest}
          cities={cities}
          districts={districts}
          towns={towns}
          user={listUser}
          LabelType={NHU_CAU}
          onChangePostType={onChangePostType}
          listTypeRealEstate={typeRealEstate}
          onChangeCity={onChangeCity}
          onChangeDistrict={onChangeDistrict}
          onChangeDepartment={onChangeDepartment}
          pagination={pagination}
          setPagination={setPagination}
          demandOps={demandOps}
          typeOfRealEstateOps={typeOfRealEstateOps}
          apartmentLocationOptions={apartmentLocationOptions}
          directionOptions={directionOptions}
          furnitureOptions={furnitureOptions}
          currentStatusOpstions={currentStatusOpstions}
          postStatusOptions={postStatusOptions}
          postSecurityOptions={postSecurityOptions}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {/* <h2 className="text-2xl font-semibold my-2">Quản lý tin BĐS nội bộ</h2> */}
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            <ExportButton
              columns={initialColumns}
              data={data?.list}
              fileName="Quan_ly_yeu_cau_tren_Web"
              sheetName="Yêu cầu trên Web"
              permission="P83.5"
            />
            {/* <Button
              type="primary"
              key="primary"
              onClick={() => {
                setIsModalImportOpen(true)
              }}
            >
              <PlusOutlined /> Import Excel
            </Button> */}
            {/* {hasPermission('P38.1', permissions) && (
              <Button
                type="primary"
                // htmlType="submit"
                onClick={() => {
                  setIsModalOpen(true)
                  setMode(ACTION_MODE.ADD)
                }}
              >
                <PlusOutlined />
                Thêm mới
              </Button>
            )} */}
            {/* <Button
              type="primary"
              // htmlType="submit"
              onClick={() => {
                if (selectedRowKeys.length == 0) {
                  openNotification('error', 'Vui lòng chọn yêu cầu')
                } else {
                  setIsModalManagerRequest(true)
                }
              }}
            >
              <DiffOutlined />
              Chọn quản lý
            </Button> */}

            {hasPermission('P83.4', permissions) && (
              <Button
                danger
                disabled={selectedRowKeys.length > 0 ? false : true}
                type="primary"
                onClick={() => {
                  showConfirm({
                    title: 'Xác nhận xoá',
                    content: (
                      <div>
                        Bạn có chắc chắn muốn xoá{' '}
                        <b>{selectedRowKeys?.length}</b> yêu cầu không?
                      </div>
                    ),
                    onOk: () => deleteRequest(selectedRowKeys)
                  })
                }}
              >
                <DeleteOutlined />
                Xoá
              </Button>
            )}
          </div>
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          data={data?.list}
          scroll={{
            x: data?.list?.length > 0 ? 'max-content' : '100%',
            y: 'calc(100vh - 400px)'
          }}
          className={`custom-table`}
          // pagination={{
          //   current: pagination.current,
          //   pageSize: pagination.pageSize,
          //   total: data?.total,
          //   pageSizeOptions: PAGE_SIZE_OPTIONS,
          //   showSizeChanger: true,
          //   onChange: handlePageChange,
          //   showTotal: (total, range) =>
          //     `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`
          // }}
          pagination={false}
          rowKey="id"
          locale={{
            emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
            triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
            triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
            cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          }}
          rowSelection={{
            selectedRowKeys: selectedRowKeys, // Mảng chứa các row được chọn
            onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys), // Xử lý khi chọn row
            type: 'checkbox', // Hoặc 'radio' nếu chỉ chọn được 1
            preserveSelectedRowKeys: true // Giữ selection khi phân trang
          }}
        />

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '16px',
            padding: '16px 0'
          }}
        >
          <Pagination
            current={pagination.current}
            pageSize={pagination.pageSize}
            total={data?.total}
            pageSizeOptions={PAGE_SIZE_OPTIONS}
            showSizeChanger={true}
            showQuickJumper={true}
            showTotal={(total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`
            }
            locale={{
              items_per_page: 'bản ghi / trang',
              jump_to: 'Đến trang',
              page: ''
            }}
            onChange={(page, pageSize) => {
              setPagination((prev) => ({
                ...prev,
                current: page,
                pageSize: pageSize || prev.pageSize
              }))
            }}
            onShowSizeChange={(current, size) => {
              setPagination((prev) => ({
                ...prev,
                pageSize: size,
                current: 1
              }))
            }}
          />
        </div>
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        // title={
        //   mode == ACTION_MODE.UPDATE
        //     ? 'Chỉnh sửa yêu cầu nội bộ'
        //     : 'Thêm mới yêu cầu nội bộ'
        // }
        title={'Chỉnh sửa yêu cầu trên web'}
        visible={isModalOpen}
        centered
        width={1200}
        // className="modal-bond"
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            if (error?.errorFields?.length > 0) {
              form.scrollToField(error.errorFields[0].name, {
                behavior: 'smooth',
                block: 'center' // Đảm bảo label không bị che
              })
            }
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
      >
        <FormPost
          form={form}
          // handleSearch={handleSearch}
          listDepartment={listDepartment}
          listUser={listUser}
          LabelType={NHU_CAU}
          ProductType={ProductType}
          typeRealEstate={typeRealEstate}
          listRequest={listRequest}
          cities={cities}
          districts={districts}
          towns={towns}
          postType={postType}
          onChangeProject={onChangeProject}
          onChangePostType={onChangePostType}
          onChangeCity={onChangeCity}
          onChangeDistrict={onChangeDistrict}
          onChangeDepartment={onChangeDepartment}
          mode={mode}
          demandOps={demandOps}
          typeOfRealEstateOps={typeOfRealEstateOps}
          apartmentLocationOptions={apartmentLocationOptions}
          directionOptions={directionOptions}
          furnitureOptions={furnitureOptions}
          legalOptions={legalOptions}
          procedureOptions={procedureOptions}
          currentStatusOpstions={currentStatusOpstions}
          postStatusOptions={postStatusOptions}
          postSecurityOptions={postSecurityOptions}
          loading={loading}
          setLoading={setLoading}
        />
      </ModalCustom>
      <FormAddExcel
        isModalOpen={isModalImportOpen}
        setIsModalOpen={setIsModalImportOpen}
        listRequest={listRequest}
        listDepartment={listDepartment}
        user={listUser}
        getListRequest={getListRequest}
        onChangeDepartment={onChangeDepartment}
        LabelType={NHU_CAU}
      />

      <ModalCustom
        title="Thêm quản lý yêu cầu"
        visible={isModalManagerRequest}
        centered
        width={600}
        onCancel={() => {
          setIsModalManagerRequest(false)
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={''}
      >
        <ManagementRequest
          setOpen={setIsModalManagerRequest}
          requestId={selectedRowKeys}
          data={listUser}
          setSelectedRowKeys={setSelectedRowKeys}
          fetchData={getListRequest}
        />
      </ModalCustom>

      <ModalCustom
        title="Danh sách quản lý note"
        visible={isModalNote}
        centered
        width={600}
        onCancel={() => {
          setIsModalNote(false)
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={''}
      >
        <Note id={recordId} />
      </ModalCustom>
      <ModalCustom
        title="Mô tả"
        visible={isModalDescription}
        centered
        width={600}
        onCancel={() => {
          setIsModalDescription(false)
        }}
        cancelText="Đóng"
        footer={''}
      >
        <Description id={recordId} loading={loading} setLoading={setLoading} />
      </ModalCustom>
      <CallModal
        id={recordId}
        isOpen={isOpenCall}
        setIsOpen={setIsOpenCall}
        listDepartment={listDepartment}
        cities={citiesAll}
        districts={districtsAll}
        towns={townsAll}
      />
      {/* <CopyModal id={recordId} isOpen={isOpenCopy} setIsOpen={setIsOpenCopy} />
      <BookModal id={recordId} isOpen={isOpenBook} setIsOpen={setIsOpenBook} /> */}
      <ModalConfirm />
    </div>
  )
}

export default ManagerRequestPostWeb
